import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Layout } from './Layout';
// LoginPage retained on disk in case auth is re-enabled; not routed while public.
import { HomePage } from '@/routes/HomePage';
import { PlacesPage } from '@/routes/PlacesPage';
import { EventsPage } from '@/routes/EventsPage';
import { ServicesPage } from '@/routes/ServicesPage';
import { RanchMapPage } from '@/routes/RanchMapPage';
import { PlaceDetailPage } from '@/routes/PlaceDetailPage';
import { FlightsPage } from '@/routes/FlightsPage';
import { BabcockNationalPage } from '@/routes/BabcockNationalPage';
import { MorePage } from '@/routes/MorePage';
import { NeighborhoodsPage } from '@/routes/NeighborhoodsPage';
import { RentalPage } from '@/routes/RentalPage';
import { MedicalPage } from '@/routes/MedicalPage';
import { EmergencyPage } from '@/routes/EmergencyPage';
import { PreparePage } from '@/routes/PreparePage';
import { ExplorePage } from '@/routes/ExplorePage';
import { TravelPage } from '@/routes/TravelPage';
import { TravelDetailsPage } from '@/routes/TravelDetailsPage';
import { FavoritesPage } from '@/routes/FavoritesPage';
import { InterestsPage } from '@/routes/InterestsPage';
import { SettingsPage } from '@/routes/SettingsPage';
import { AdminPage } from '@/routes/AdminPage';
import { GuestPage } from '@/routes/GuestPage';

// Auth disabled — the app is fully public. No loading gate, no anonymous
// branch, no LoginPage route. /login redirects to home so any stale
// bookmarks still work.

/** Keep ?locality= (and any other query) when aliasing a renamed route. */
export function RedirectPreserveSearch({ to }: { to: string }) {
  const { search } = useLocation();
  return <Navigate to={{ pathname: to, search }} replace />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route path="/guest" element={<Layout />}>
        <Route index element={<GuestPage />} />
      </Route>
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/places" element={<PlacesPage />} />
        <Route path="/favorites" element={<InterestsPage />} />
        <Route path="/interests" element={<RedirectPreserveSearch to="/favorites" />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/map" element={<RanchMapPage />} />
        <Route path="/places/:slug" element={<PlaceDetailPage />} />
        <Route path="/flights" element={<FlightsPage />} />
        <Route path="/babcock" element={<Navigate to="/babcock/national" replace />} />
        <Route path="/babcock/national" element={<BabcockNationalPage />} />
        <Route path="/more" element={<MorePage />} />
        <Route path="/neighborhoods" element={<NeighborhoodsPage />} />
        <Route path="/rental" element={<RentalPage />} />
        <Route path="/medical" element={<MedicalPage />} />
        <Route path="/emergency" element={<EmergencyPage />} />
        <Route path="/prepare" element={<PreparePage />} />
        <Route path="/explore" element={<ExplorePage />} />
        <Route path="/travel" element={<TravelPage />} />
        <Route path="/travel-details" element={<TravelDetailsPage />} />
        <Route path="/family-favorites" element={<FavoritesPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
